import {
  NotificationType,
  NotificationTypeTitle
} from 'Enums/NotificationType';

export const GetNotificationTypeTitle = (typeId: number) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  NotificationTypeTitle[NotificationType[typeId]];
